import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useDetectUserwayBiggerText } from '../../shared/hooks/useDetectUserwayBiggerText';
import WhitePopUpNoTitle from '../../shared/modal/whitePopUp/WhitePopUpNoTitle';
import { getProfileSettingsTitle } from '../../shared/util/profile';
import { ProfileStatsLeftMenu } from './ProfileStatsLeftMenu';
import { ProfileStatsRightMenu } from './ProfileStatsRightMenu';

type ProfileStatsProps = {
  hide: boolean;
};

export function ProfileStats({ hide }: ProfileStatsProps) {
  const { isBiggerText } = useDetectUserwayBiggerText();
  const { t } = useTranslation();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const subMenuOptions = [
    { id: 61, title: 'streaks' },
    { id: 62, title: 'stats' },
  ];
  const [activeSubMenu, setActiveSubMenu] = useState(subMenuOptions[0]);

  const [showLeftMenu, setShowLeftMenu] = useState(true);

  useEffect(() => {
    if (hide) {
      setShowLeftMenu(false);
    } else {
      setShowLeftMenu(true);
    }
  }, [hide]);

  const changeSubMenu = (props) => {
    setActiveSubMenu(subMenuOptions[props]);
  };

  const handleModalOpen = (value: boolean) => {
    setModalIsOpen(value);
  };

  return (
    <div className="profile-container">
      {showLeftMenu && (
        <div
          className={`menu-left ${isBiggerText ? 'small-padding' : ''}`}
          role="region"
          aria-label={t('profile.stats.title')}
        >
          <ProfileStatsLeftMenu changeSubMenu={changeSubMenu} activeSubMenu={activeSubMenu} />
        </div>
      )}
      <div
        className={`menu-right ${hide ? 'simplify' : ''}`}
        role="region"
        aria-label={getProfileSettingsTitle(activeSubMenu?.title)}
      >
        <ProfileStatsRightMenu
          activeSubMenu={activeSubMenu}
          hide={hide}
          handleModalOpen={handleModalOpen}
        />
      </div>
      {modalIsOpen && (
        <WhitePopUpNoTitle
          returnFocus
          popupContents={{ title: t('S047'), text: [t('S130')] }}
          ctaBtn={t('T015')}
          handleSubmit={() => setModalIsOpen(false)}
          dialogTitle={t('modal.stats.explanation')}
        />
      )}
    </div>
  );
}
